import { useEffect } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

interface IScrollToActiveStoreProps {
  activeStoreId?: string;
  nearbyStoreCardRefs?: {
    [key: string]: React.MutableRefObject<HTMLDivElement | null>;
  };
  scrollContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  tabContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  canScroll: boolean;
}

/**
 * Scrolls to active store card when active store changes
 */
export default ({
  activeStoreId,
  nearbyStoreCardRefs,
  scrollContainerRef,
  tabContainerRef,
  canScroll,
}: IScrollToActiveStoreProps) => {
  // TODO: remove this whole hook once new UI feature rolls out
  //       or figure out a better way to decouple this beforehand
  const enableLocatorUIRefresh = useFlag(LaunchDarklyFlag.ENABLE_LOCATOR_UI_REFRESH);

  const activeStoreCard = activeStoreId && nearbyStoreCardRefs?.[activeStoreId]?.current;
  const scrollContainer = scrollContainerRef.current;

  const tabOffset = tabContainerRef.current?.clientHeight || 0;

  useEffect(() => {
    if (!canScroll || !activeStoreCard || !scrollContainer || enableLocatorUIRefresh) {
      return;
    }

    // Account for fixed tab container when scrolling vertically
    if (tabOffset > 0) {
      const top =
        scrollContainer.scrollTop +
        activeStoreCard.getBoundingClientRect().top -
        scrollContainer.getBoundingClientRect().top -
        tabOffset;
      // Old javascript contexts do not support `scrollTo`
      scrollContainer.scrollTo?.({
        top,
        behavior: 'smooth',
      });
      return;
    }

    activeStoreCard.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
    });
  }, [
    activeStoreCard,
    activeStoreId,
    canScroll,
    enableLocatorUIRefresh,
    scrollContainer,
    tabOffset,
  ]);
};
